export default __webpack_public_path__ + "static/media/ammzion.5a09da24.png";